import { getReferenceString } from '@medplum/core';
import { Patient } from '@medplum/fhirtypes';
import type { PacQueueHydration } from '../hooks/usePacQueueHydration';
import { buildFinancingRows, FinancingLeadRow } from './financingRows';
import { PayorCell, payorCellFor, PnConsultationCell, pnConsultationFor } from './listRowShared';
import { isOpenCase } from './readyToScheduleScope';

export interface CoverageRow extends FinancingLeadRow {
  pnConsultation?: PnConsultationCell;
  payor?: PayorCell;
}

/** The Financing rows (BAR-3097), with the PN consultation and the payor the Coverage tabs show. */
export function buildCoverageRows(
  patients: Patient[],
  hydration: PacQueueHydration,
  now: Date,
  showPaymentStatus: boolean
): CoverageRow[] {
  return buildFinancingRows(patients, hydration, now, {}, showPaymentStatus, isOpenCase).map((row) => ({
    ...row,
    pnConsultation: pnConsultationFor(hydration, getReferenceString(row.patient) ?? '', now),
    payor: payorCellFor(row.track, row.employer, row.paymentStatus),
  }));
}
